<template>
  <div class="role-container">
    <div class="choose-role">
      <WorkbenchTitle title="选择角色"></WorkbenchTitle>
      <div class="close" @click="clickClose"></div>
      <div class="role-list">
        <template v-for="(item, index) in roleList">
          <div
            :key="index"
            :class="['role-item', item.icon]"
            @click="clickRoleItem(item)"
          >
            {{ item.name }}
            <template v-if="item.check">
              <el-popover
                placement="bottom-start"
                title=""
                width="100"
                trigger="hover"
                content="原登录账号已绑定"
              >
                <div slot="reference" class="role-check"></div>
              </el-popover>
            </template>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import WorkbenchTitle from "@/components/WorkbenchTitle";
import { mapState, mapMutations } from "vuex";
import { setToken } from "@/utils/auth";
import { PLATFORMS, ROLE_DIST } from "@/utils/enum";
import { fetchLogin } from "@/api/login";
import todoMixin from "@/mixins/todoMixin";
import { fetchBindList } from "@/api/bind";
// import { getToken } from "@/utils/auth";
import { isObject, isArray } from "@/utils/is";
export default {
  name: "WorkbenchRole",
  mixins: [todoMixin],
  computed: {
    ...mapState("user", ["platform", "role", "redirect", "common_token"]),
  },
  components: {
    WorkbenchTitle,
  },
  data() {
    return {
      ROLE_DIST,
      roleList: [],
    };
  },
  mounted() {
    const { platform } = this;
    const platformInfo = PLATFORMS[platform];
    if (platformInfo) {
      const { role_enum } = platformInfo;
      const roleObj = this.ROLE_DIST[role_enum];
      let roleList = [];
      for (let key in roleObj) {
        if (key == "patient") continue;
        const val = roleObj[key];
        val.check = false;
        roleList.push(val); 
      }
      console.log(platform, platformInfo, roleList,'roleList');
      this.roleList = roleList;
      this.getBindList();
    }
  },
  methods: {
    ...mapMutations("user", ["SET_DATA"]),
    clickClose() {
      this.$router.replace({
        name: "WorkbenchHome",
      });
    },
    getBindList() {
      const { common_token } = this;
      fetchBindList({
        common_token,
      }).then((res) => {
        const { code, data } = res;
        if (code === 0) {
          isObject(data) && this.handleBindList(data);
        }
      });
    },
    handleBindList(data) {
      const { platform, roleList } = this;
      const roleBindList = data[platform];
      if (isArray(roleBindList) && roleBindList.length) {
        let setList = [];
        roleList.map((el, index) => {
          const { key } = el;
          roleBindList.map((item) => {
            console.log(item.role, key);
            if (item.role === key) {
              setList.push(index);
            }
          });
        });
        setList.map((el) => {
          let roleItem = roleList[el];
          roleItem.check = true;
          this.$set(this.roleList, el, roleItem);
        });
      }
    },
    clickRoleItem(item) {
      const { platform, common_token } = this;
      const { key } = item;
      this["SET_DATA"]({
        role: key,
      });
      fetchLogin({
        platform,
        role: key,
        common_token,
      }).then((res) => {
        console.log(res);
        const { code, data, msg } = res;
        if (code === 0) {
          //登录成功
          const { do: todo, common_token } = data;
          setToken(common_token);
          this["SET_DATA"]({
            login_todo: todo,
            common_token,
          });

          this.handleTodo(todo, true);
        } else if (code === 1) {
          //登录失败
          const { do: todo } = data;
          if (!todo) {
            this.$message({
              message: msg,
              type: "error",
            });
          } else {
            this.handleTodo(todo, false);
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
